import { set } from 'lodash';
import { RootState } from '../../store';
import { TExpressionsCollection } from './types';

const createExpFn = (varNames: string[], expString: string, name: string) => {
  try {
    const cleaned = expString.trim().replace(/\s+/g, ' ');
    return new Function(...varNames, cleaned);
  } catch {
    return () => console.error('Ошибка преобразования выражения ' + name + ' в функцию');
  }
};

export const constructExpressions = (
  expState: RootState['site']['expressions']
): TExpressionsCollection => {
  const expr = {};
  for (const expObj of Object.values(expState)) {
    set(
      expr,
      expObj.name,
      createExpFn(expObj.variables?.replace(/\s+/g, '').split(/[;,]/), expObj.value, expObj.name)
    );
  }
  return expr;
};
